module.exports = "<a :href=\"card.url\" class=\"card\" :style=\"{ 'background-image': 'url(' + card.img + ')' }\">\n    <div class=\"card__content\">\n        <div class=\"o-color-line\" :style=\"{ 'background-color': card.color }\"></div>\n        <p class=\"card__heading\">{{ card.title }}</p>\n    </div>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/card/card.vhtml
// module id = 311
// module chunks = 0